import { activity_record_types } from "./activity_record_types";

export const manual_automation_records = [
    activity_record_types.JOB,
    activity_record_types.CLIENT,
    activity_record_types.CANDIDATE,
    activity_record_types.APPLICATION,
    activity_record_types.CUSTOM_ENTITY,
    activity_record_types.CONTACT,
] as const;